import { connect } from 'react-redux';
import {
    getEnableNewRebrandingLogoAnimationFF,
    getIsAppRebrandActive,
} from '../../selectors/app';
import { CheckoutState } from '../../state';

const mapStateToProps = (
    state: CheckoutState,
): Partial<{
    isAppRebrandActive: boolean;
    isNewRebrandingLogoAnimationEnabled: boolean;
}> => ({
    isAppRebrandActive: getIsAppRebrandActive(state),
    isNewRebrandingLogoAnimationEnabled:
        getEnableNewRebrandingLogoAnimationFF(state),
});

export type ConnectedProps = ReturnType<typeof mapStateToProps>;

const connectLoadingPage = connect(mapStateToProps);

export default connectLoadingPage;
